module.exports = __webpack_public_path__ + "img/4532f90a307920f4539e0b0ac5fc6417.svg";